var map = {
	"./affordable-and-clean-energy.png": "d8ab",
	"./clean-water-and-sanitation.png": "8567",
	"./climate-action.png": "2175",
	"./decent-work-and-economic-growth.png": "9c58",
	"./end-poverty.png": "b4c0",
	"./gender-equality.png": "aa21",
	"./good-health-and-well-being.png": "36c7",
	"./industry-innovation-and-infrastructure.png": "4fb9",
	"./life-below-water.png": "cbc4",
	"./life-on-land.png": "1146",
	"./partnerships-for-the-goals.png": "920b",
	"./peace-justice-and-strong-institutions.png": "6826",
	"./quality-education.png": "d496",
	"./reduced-inequalities.png": "0426",
	"./responsible-consumption-and-production.png": "202d",
	"./sustainable-cities-and-communities.png": "8cf3",
	"./zero-hunger.png": "bb04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08a4";